import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';

import PageBaseProps from 'types/PageBase';

import classNames from 'classnames';
import { Icon, PageHeader } from '../ui';
import Footer from '../ui/PageFooter';

const instructions = [
  {
    key: 'PARKED_CAR',
    icon: 'fb-icon--parking-car',
    title: {
      id: 'breakdownService.instructions.parkVehicle',
      defaultMessage: 'Park the vehicle',
    },
  }, {
    key: 'CAR',
    icon: 'fb-icon--module-bodywork',
    title: {
      id: 'breakdownService.instructions.rememberPlate',
      defaultMessage: 'Remember the licence plate',
    },
  }, {
    key: 'DOCUMENT_CAR',
    icon: 'fb-icon--car-document',
    title: {
      id: 'breakdownService.instructions.carDocument',
      defaultMessage: 'Make sure the vehicle documents are inside the vehicle',
    },
  }, {
    key: 'HAND_KEY',
    icon: 'fb-icon--hand-check-in',
    title: {
      id: 'breakdownService.instructions.keyReady',
      defaultMessage: 'Take the keys of the vehicle',
    },
  }, {
    key: 'PHONE',
    icon: 'fb-icon--devices',
    title: {
      id: 'breakdownService.instructions.phone',
      defaultMessage: 'Take your cell phone',
    },
  }];

const BreakdownInstructions: React.FC<PageBaseProps> = ({ onNext }) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleOnPrev = React.useCallback(() => {
    navigate(`/${search}`);
  }, [navigate, search]);

  return (
    <>
      <PageHeader
        hideSteps
        onPrev={handleOnPrev}
        title={<FormattedMessage id="home.breakdown" defaultMessage="No appointment" />}
      />
      <div className="main-content">
        <div className="flex flex-col items-center">
          <h3 className="mt-10 kiosk:mt-20 kioskSharebox:mt-10">
            <FormattedMessage
              id="breakdownService.beforeStarting"
              defaultMessage="Before starting"
            />
          </h3>
          {/* eslint-disable-next-line max-len */}
          <div className="mt-2 kiosk:mt-4 mb-10 kiosk:mb-20 kioskSharebox:mb-10 kiosk:px-24 kioskSharebox:px-0 kioskSharebox:grid kioskSharebox:grid-cols-2 kioskSharebox:gap-8">
            {instructions.map(({ icon, title, key }) => (
              <div className="flex flex-row items-center py-6  kiosk:py-16 kioskSharebox:py-6 border-b last:border-b-0" key={key}>
                <div className="bg-card-bg rounded-card p-4 flex">
                  <Icon className={classNames(icon, 'text-2xl kiosk:text-6xl text-default')} />
                </div>
                <p className="ml-5 kiosk:ml-10 font-medium text-low">
                  <FormattedMessage {...title} />
                </p>
              </div>
            ))}
          </div>
        </div>
        <Footer
          onNext={onNext}
          onPrev={handleOnPrev}
          shouldDisplayBackButton
        />
      </div>
    </>
  );
};

export default BreakdownInstructions;
